module.exports = __webpack_public_path__ + "img/s2.dc88b4e8.png";